module.exports = __webpack_public_path__ + "static/vregattaHome_2-6b4acdbc61fa8b4dcc8f7a2ce6282dd2.png";